<template>
  <section>
    
    <h1 class="section-head">รายละเอียดการสั่งซื้อ {{order.code}} - {{order.sup_name}}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-info" @click="download" :class="loadingClass" v-can="'download_po_pdf'"><i class="fas fa-download"></i>ดาวโหลดใบสั่งซื้อ</button>
            <router-link class="button is-warning" :to="('/purchaseorder/edit/'+this.$route.params.id)" v-if="order.received_status != 'received'" v-can="'add_po|edit_po'"><i class="fas fa-pencil-alt"></i>แก้ไข</router-link>
            <router-link class="button is-success" :to="('/purchaseorder/receive/'+this.$route.params.id)" v-if="order.received_status != 'received'" v-can="'receive_po_item'"><i class="fas fa-box-open"></i>รับสินค้า</router-link>
          </div>
        </div>
      </div>
    </nav>

    <div>
      <b-table
        class="table-style"
        :data="order.items"
        :hoverable="true"
        :loading="isLoading"
        v-if="products.length > 0 || this.isLoading"
      >
        <template slot-scope="props">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="200">
              {{ props.row.name }}
          </b-table-column>

          <b-table-column field="price_buy" label="ราคาชื้อ" width="130">
              {{ parseFloat(props.row.price).formatMoney(2) }} บาท/{{ props.row.unit_text }}
          </b-table-column>

          <b-table-column label="ส่วนลด(%)" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="ส่วนลด %" :value="props.row.discount+'%'" readonly>
              </p>
            </div>
          </b-table-column>

          <b-table-column label="ส่วนลด(฿)" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="ส่วนลด ฿" :value="props.row.discount_baht+' บาท'" readonly>
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static  is-small" type="text" placeholder="จำนวนสั่ง" :value="parseFloat(props.row.quantity).formatMoney(0)+' '+props.row.unit_text" readonly>
              </p>
            </div>
          </b-table-column>

          <b-table-column label="รวม" width="130">
              <input class="input is-static  is-small" type="text" placeholder="รวม" :value="parseFloat(props.row.total_price).formatMoney(2)+' บาท'" readonly>
          </b-table-column>


          <b-table-column field="received" label="จำนวนรับ" width="80">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static is-small" type="text" placeholder="จำนวนรับ" :value="parseFloat(props.row.received).formatMoney(0)+' '+props.row.unit_text" readonly>
              </p>
            </div>
          </b-table-column>

          <b-table-column label="จำนวนค้างรับ" width="120">
            <div class="field has-addons">
              <p class="control">
                <input class="input is-static  is-small" type="text" placeholder="คงเหลือ" :value="parseFloat(props.row.quantity-props.row.received).formatMoney(0)+' '+props.row.unit_text" readonly>
              </p>
            </div>
          </b-table-column>

          <b-table-column label="Remark" width="250">
              <input class="input is-static  is-small" type="text" placeholder="Remark" :value="props.row.remark" readonly>
          </b-table-column>

          <b-table-column label="จัดส่งที่" width="250">
              {{ props.row.cus_name ? props.row.cus_name : "จัดส่งเข้าบริษัท" }}
          </b-table-column>


        </template>
      </b-table>
      
      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>
      
    </div>

    <h1 class="section-head">รายละเอียดการรับสินค้า</h1>

    <div v-for="receivedItemLoop in receivedList" v-bind:key="receivedItemLoop.code_id">
      <h3 class="section-sub-head">วันที่ {{receivedItemLoop.cr_date}}</h3>
      <div>
        <b-table
          class="table-style"
          :data="receivedItemLoop.items"
          :hoverable="true"
          :loading="isLoading"
          v-if="receivedItemLoop.items.length > 0"
        >
          <template slot-scope="props">
            <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="200">
                {{ props.row.name }}
            </b-table-column>


            <b-table-column field="quantity" label="จำนวนรับ" width="80">
              <div class="field has-addons">
                <p class="control">
                  <input class="input is-static is-small" type="text" placeholder="จำนวนรับ" :value="parseFloat(props.row.quantity).formatMoney(0) + ' ' + props.row.unit_text" readonly>
                </p>
              </div>
            </b-table-column>

            <b-table-column label="จัดส่งที่" width="250">
                {{ props.row.cus_name ? props.row.cus_name : "จัดส่งเข้าบริษัท" }}
            </b-table-column>


          </template>
        </b-table>
        
        <div class="notification has-text-centered" v-else>ไม่มีรายการรับสินค้า</div>
        
      </div>
    </div>






  </section>
</template>

<script>
  import Request from '@/libraries/request';
  import ProductModel from '@/model/product_model';
  import SupplierModel from '@/model/supplier_model';
  import PurchaseOrderModel from '@/model/purchaseorder_model';
  import Const from '@/const/const';
  import Config from '@/libraries/config';

  export default {
    data() {
      return {
        order: [],
        unitList: Const,
        supId: this.$route.params.supId ? this.$route.params.supId : null,
        isLoading: true,
        backPage: this.$route.params.supId ? '/supplier/view/'+this.$route.params.supId : '/purchaseorder',
        supplier: {},
        supplierList: {},
        products: [],
        receivedList: [],
        alert: {
          supplier: {
            type: '',
            msg: ''
          }
        },
        loadingClass: ""
      }
    },
    mounted() {
      this.isLoading = true;
      this.init();
    },
    methods: {
      async init(){
        try{        
          if(this.$route.params.id){
            this.order = await PurchaseOrderModel.get_order(this.$route.params.id);
            this.supId = this.order.sup_id;
            //console.log(parseFloat(this.order.total_price).formatMoney(2));
            
            this.receivedList = await PurchaseOrderModel.get_receivedList(this.$route.params.id);
          }
          if(this.supId){
            this.supplier = await SupplierModel.get_supplier(this.supId);
            this.products = await ProductModel.get_supplier_product(this.supId);
          }
          
          this.isLoading = false;
        }catch(e){
          this.$buefy.snackbar.open(e.message);
          this.$router.push('/supplier/view/'+this.supId);
        }
      },
      download(){
        this.loadingClass = "is-loading";
        window.open(Config.baseUrl + "/" + this.order.pdf_path);
        this.loadingClass = "";
      }
    }
  }
</script>
<style scoped>
  .table-style {
    font-size: 0.8rem;
  }
</style>


// WEBPACK FOOTER //
// src/pages/PurchaseOrder/view.vue